<template>
    <div id="standard" style="width:100%;height: 100%;padding: 20px;background: white;box-sizing:border-box"
        v-loading.fullscreen.lock.body="loading" :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <div style="width: 100%;">
            <el-row style="margin-bottom: 20px;">
                <el-col :span="6"><span style="font-weight: bold; font-size: larger;">资料群发任务</span></el-col>
                <el-col :span="12" style="text-align: center;">

                </el-col>
                <el-col :span="6"></el-col>
            </el-row>
            <el-form label-width="120px">
                <el-row>
                    <el-row style="margin-top: 20px">
                        <el-col :span="12">
                            <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">任务名称
                            </span>
                            <el-input type="text" v-model="searchForm.task_name" placeholder="请输入任务名称"
                                style="width:calc(100% - 120px)">
                            </el-input>
                        </el-col>
                        <el-col :span="12" style="text-align: right">
                            <span style="font-weight: bold;margin-right: 10px;display: inline-block;width: 70px">资料名称
                            </span>
                            <el-select v-model="searchForm.material_id" placeholder="请选择资料名称"
                                style="width: calc(100% - 90px)" clearable>
                                <el-option v-for="item in material_array" :key="item.material_id" :label="item.title"
                                    :value="item.material_id">
                                </el-option>
                            </el-select>
                        </el-col>
                    </el-row>
                </el-row>

            </el-form>
        </div>
        <el-row style="margin-top:21px;border-bottom: 2px dotted rgb(231, 234, 236);padding-bottom: 20px;">
            <el-button type="primary" size="small" @click.stop="handleQueryClick">查询</el-button>
            <el-button type="danger" size="small" @click.stop="handleResetClick">重置</el-button>
        </el-row>
        <div style="width: 100%;margin-top:10px;">
            <el-row style="margin-top:20px;">
                <el-button type="success" size="small" icon="el-icon-plus" @click.stop="handleAddClick">添加群发任务
                </el-button>
            </el-row>
            <el-table :header-cell-style="{'color':'black','font-size':'15px'}" :data="tableData" border
                style="width: 100%;margin-top: 20px" stripe>
                <el-table-column align="center" type="index" label="序号" width="60px">
                </el-table-column>
                <el-table-column prop="task_name" label="任务名称">
                </el-table-column>
                <el-table-column prop="title" label="资料名称">
                </el-table-column>
                <el-table-column width="180" prop="sendcount" label="发送医生人数">
                </el-table-column>
                <el-table-column width="140" label="状态">
                    <template slot-scope="scope">
                        {{ scope.row.status=='ACTIVE' ?'已发送' :"未发送" }}
                    </template>
                </el-table-column>
                <el-table-column width="180" prop="send_date" label="发送日期">
                </el-table-column>
                <el-table-column label-class-name="conference_table_cell" fixed="right" label="操作" width="80"
                    style="color: #3b99f7">
                    <template slot-scope="scope">
                        <el-button type="warning" size="small" @click="handleDetail(scope.row)">详情
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row style="margin-bottom: 20px">
                <el-col>
                    <pagination :page="page" @changePage="changePageClick"></pagination>
                </el-col>
            </el-row>
        </div>
    </div>

</template>

<script>
    import navBar from '../../components/navBar'
    import http from '../../APIService/http'
    import pagination from "../../components/pagination";
    import xlsx from "xlsx";
    import { MessageBox, Message } from 'element-ui'
    import { export_json_to_excel } from "../../vendor/Export2Excel";
    import moment from 'moment'
    export default {
        name: "speaker",
        data() {
            return {
                loading: false,
                loadingText: "",
                tableData: [],
                page: this.GLOBAL.page_bulk_send,
                material_array: [],
                searchForm: {
                    task_name: "",
                    material_id: "",
                    status: "ACTIVE"
                },
            }
        },
        components: {
            navBar,
            pagination
            // Upload
        },
        created() {
            this.getMaterialArray();
            this.init();
        },
        mounted() {
            // document.getElementById('main').scrollTo(0, 0)
        },
        updated() {
        },
        methods: {
            getShowLevel(code) {
                debugger;
                let level = this.speaker_level_array.find(e => e.key == code);
                return level ? level.title : "";
            },
            async getMaterialArray() {
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        type: "SPEAKER_LEVEL"
                    }
                    await http.post('/crm/dictionary/getDictionaryByType', data).then(res => {
                        if (res.success === true) {
                            this.speaker_level_array = res.data;
                        }
                    })
                } catch (e) {

                }
            },
            async init() {
                this.loading = true;
                try {
                    let user = this.$store.getters.getUser
                    let data = {
                        tenant_id: user.tenant_id,
                        user_id: user.user_id,
                        limit: this.page.size,
                        offset: this.page.current - 1,
                        task_name: this.searchForm.task_name,
                        material_id: this.searchForm.material_id
                    }
                    await http.post('/echo/web/material_bulk/getTaskList', data).then(res => {
                        this.loading = false;
                        debugger;
                        if (res.success === true) {
                            // console.log(res)
                            this.page.total = parseInt(res.data.total)
                            this.tableData = res.data.array;
                        }
                    })
                } catch (e) {
                    this.loading = false;
                    Message({
                        type: "error",
                        message: JSON.stringify(e),
                    });
                } finally {
                    this.loading = false;
                }
            },
            handleChangeStatus(e) {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.searchForm.status = e;
                this.init();
            },
            handleQueryClick() {
                this.page = {
                    current: 1,
                    size: 5,
                    total: 0
                }
                this.init()
            },
            handleResetClick() {
                this.searchForm.task_name = "";
                this.searchForm.material_id = "";
                this.init()
            },
            async handleAddClick(row) {
                debugger;
                this.$router.push({
                    name: 'echoLibraryBulkDetail',
                })
            },
            async handleDetail(row) {
                debugger;
                this.$router.push({
                    name: 'echoLibraryBulkDetail',
                    params: {
                        row: row
                    },
                })
            },
        },
        beforeRouteLeave(to, from, next) {

            // // 打开详情页（或者下一个任意界面）之前，把筛选条件保存到localStorage，如果离开列表页并且打开的不是详情页则清除，也可以选择不清除
            // if (to.name === 'meetInfo' && to.params.type != 'new') {
            //     let condition = JSON.stringify(this.searchForm)
            //     localStorage.setItem('condition', condition)
            // } else {
            //     localStorage.removeItem('condition')
            // }
            // if (to.name !== 'meetInfo') {
            //     this.GLOBAL.page_speaker = {
            //         current: 1,
            //         size: 5,
            //         total: 0
            //     }
            // }
            next()
        }
    }
</script>


<style>
    #add_speaker .el-tag {
        color: #fff;
        background: #ff9901;
        border: none;
    }

    #add_speaker .el-tag.el-tag--info .el-tag__close {
        display: none;
    }

    #edit_speaker .el-tag {
        color: #fff;
        background: #ff9901;
        border: none;
    }

    #edit_speaker .el-tag.el-tag--info .el-tag__close {
        display: none;
    }
</style>

<style scoped>
    #standard>>>.el-dialog__header {
        border-bottom: 2px dashed #eee;
        padding: 20px 0 10px;
        margin: 0 20px;
    }

    #standard>>>.el-dialog__body {
        padding-top: 20px;
    }

    #standard>>>.el-form-item__label {
        text-align: left;
        font-weight: bold;
        font-size: 16px;
    }

    #standard>>>.standard_star label:after {
        content: "*";
        color: #f56c6c;
        margin-left: 4px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/echo/library_bulk.vue